import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  height: 100vh;
  align-content: center;
  justify-content: center;
`;
